import {
  GetPrayerStreamErrorResponseDtoStatus,
  GetPrayerStreamSuccessResponseDtoStatus,
  ResponseMetadataMessageDtoLevel,
} from '@ccm-innovation/member-center-bff-sdk-axios';
import { assert, UnreachableCaseError } from 'ts-essentials';
import { call, put, takeLeading } from 'typed-redux-saga';
import { PrayerStreamApiService } from '../../../services/prayer-stream';
import { getAccessTokenSaga } from '../../auth/accessToken.saga';
import { PrayerStreamUserStatus, streamSlice } from '../../stream/stream.slice';
import { getContainer } from '../../utils.saga';
import { getPrayerStreamUserRegistrationSlice } from './get-prayer-stream-user-registration.slice';

export function* getPrayerStreamUserRegistrationSaga(): Generator {
  const container = yield* getContainer();
  const { prayerStreamApi } = container.get(PrayerStreamApiService);

  yield* put(
    getPrayerStreamUserRegistrationSlice.actions.getPrayerStreamUserRegistrationStarted(),
  );

  const accessToken = yield* getAccessTokenSaga();
  assert(accessToken);

  // TODO: Create wrapper function to handle Axios errors.
  const { data } = yield* call(async () => {
    try {
      return await prayerStreamApi.prayerStreamControllerGetMemberStatusV1({
        headers: { Authorization: `Bearer ${accessToken}` },
      });
    } catch (error) {
      return {
        data: {
          metadata: {
            messages: [
              {
                level: ResponseMetadataMessageDtoLevel.ERROR,
                text: `PrayerStream level error: ${(error as Error).message}`,
              },
            ],
            requestId: '001',
          },
          status: GetPrayerStreamErrorResponseDtoStatus.OTHER,
        },
      };
    }
  });

  const { status } = data;

  switch (status) {
    case GetPrayerStreamErrorResponseDtoStatus.ACCESS_DENIED:
    case GetPrayerStreamErrorResponseDtoStatus.OTHER:
      yield* put(
        getPrayerStreamUserRegistrationSlice.actions.getPrayerStreamUserRegistrationFailed(
          status,
        ),
      );
      break;
    case GetPrayerStreamErrorResponseDtoStatus.NOT_FOUND:
      yield* put(
        getPrayerStreamUserRegistrationSlice.actions.getPrayerStreamUserRegistrationSucceeded(
          status,
        ),
      );
      yield* put(
        streamSlice.actions.setPrayerStreamUserStatus(
          PrayerStreamUserStatus.NOT_REGISTERED,
        ),
      );
      break;
    case GetPrayerStreamSuccessResponseDtoStatus.SUCCESS: {
      yield* put(
        getPrayerStreamUserRegistrationSlice.actions.getPrayerStreamUserRegistrationSucceeded(
          status,
        ),
      );

      const { payload } = data;
      yield* put(streamSlice.actions.setPrayerStreamUserDetails(payload));
      yield* put(
        streamSlice.actions.setPrayerStreamUserStatus(
          PrayerStreamUserStatus.REGISTERED,
        ),
      );
      break;
    }

    /* v8 ignore next 2 */
    default:
      throw new UnreachableCaseError(status);
  }
}
export function* watchGetPrayerStreamUserRegistrationSaga(): Generator {
  yield* takeLeading(
    getPrayerStreamUserRegistrationSlice.actions
      .getPrayerStreamUserRegistrationRequested,
    function* lambda(action) {
      yield* call(getPrayerStreamUserRegistrationSaga, action.payload);
    },
  );
}
